// Primary CTA for starting a brand-new agent session from the project
// dashboard. Used when `needsConfig` is true (so the dashboard doesn't show
// the `Start X` / `Resume X` buttons near line 910) and there is no
// `activeSession` yet — previously that combination plus the AGENT.A3
// feature flag left the dashboard with no actionable entry point.
//
// Navigation is deliberately phase-agnostic (`/projects/:id/chat`); the
// ChatPage resolves which agent to instantiate from the project's current
// phase, so a single URL works for every phase in PHASE_AGENTS.

interface Props {
  /** Called when the user clicks the button; expected to navigate to the chat page. */
  onStart:          () => void;
  /** Used in the button label so the user knows who they're about to talk to. */
  agentDisplayName: string;
}

export default function StartSessionButton({ onStart, agentDisplayName }: Props) {
  return (
    <button
      data-testid="start-session-btn"
      onClick={onStart}
      className="flex items-center gap-2 px-4 py-2 rounded-lg text-white transition-all hover:shadow-[0_4px_14px_rgba(124,58,237,0.25)]"
      style={{
        background:  'var(--primary)',
        fontFamily:  'var(--font-body)',
        fontSize:    14,
        fontWeight:  600,
      }}
    >
      <span>🚀</span>
      Start Session with {agentDisplayName} →
    </button>
  );
}
